if (!Shopify.designMode && !localStorage.getItem("country_popup_closed")) {
    fetch("https://get.geojs.io/v1/ip/geo.json")
      .then(res => res.json())
      .then(data => {
        
        const countryCode = data.country_code;
        const currentHost = window.location.hostname;
        
        // Define store domains for each country
        const stores = {
          "AU": {
            domain: "mypaperclip.com.au",
            name: "Australia Store",
            link: "https://mypaperclip.com.au/"
          },
          "IN": {
            domain: "paperclipstore.in",
            name: "India Store",
            link: "https://paperclipstore.in/"
          },
          "US": {
            domain: "mypaperclip.co",
            name: "US Store",
            link: "https://mypaperclip.co/"
          }
        };

        const userStore = stores[countryCode];
        const storeCountry = getStoreCountryFromDomain();
        const currentStore = stores[storeCountry];
        ///alert(storeCountry);
        ///alert(userStore.domain);
        if (userStore && !currentHost.includes(userStore.domain)) {
         
          setTimeout(function() {
            document.getElementById("popup-heading").innerText = `Yes, continue on ${currentStore.name}`;
            document.getElementById("btn-cc-website").innerText = `Yes, continue on ${currentStore.name}`;
            document.getElementById("btn-cc-website").href = `javascript:(0);`;
            document.getElementById("btn-other-website").innerText = `No, go to the website for ${data.country}`;
            document.getElementById("btn-other-website").href = `${userStore.link}`;
            document.getElementById("separate-country").style.display = "block";
            document.getElementById("global-country").style.display = "none";
            document.getElementById("country-popup").style.display = "flex";
          }, 0);
        }else if(!userStore){
          setTimeout(function() {
            document.getElementById("separate-country").style.display = "none";
            document.getElementById("global-country").style.display = "block";
            document.getElementById("country-popup").style.display = "flex";
            document.getElementById("popup-heading").innerText = `We are available on different location. Please choose current location`;
            
          }, 0);
        }
      });

      document.addEventListener("DOMContentLoaded", function () {
        
          document.getElementById("btn-cc-website").addEventListener("click", function () {
            document.getElementById("country-popup").style.display = "none";
            localStorage.setItem("country_popup_closed", "true");
          });

          document.querySelectorAll(".btn-click").forEach(button => {
            button.addEventListener("click", function () {
              localStorage.setItem("country_popup_closed", "true");
    
              // If button is an <a> with href, redirect after storing
              const href = button.getAttribute("href");
              if (href) {
                e.preventDefault(); // stop default link behavior
                setTimeout(() => {
                  window.location.href = href; // redirect manually
                }, 100); // small delay to ensure localStorage saves
              } else {
                // No href? Just close the popup
                document.getElementById("country-popup-overlay").style.display = "none";
              }
            });
          });
        
      });
  }

function getStoreCountryFromDomain() {
  const hostname = window.location.hostname;

  if (hostname.endsWith(".in")) return "IN";
  if (hostname.endsWith(".com.au")) return "AU";
  if (hostname.endsWith(".co")) return "US";


  return "Unknown";
}

